import React from "react";
import Article from "../../components/article/Article";
import "./blog.css";

const blogUrl = "/assets/img/demoblog.png";

const Blog = () => (
  <section className="scrobits__blog section__padding" id="blog">
    <div className="scrobits__blog-heading">
      <h1 className="gradient__text">
        A lot is happening, <br /> We are blogging about it.
      </h1>
    </div>
    <div className="scrobits__blog-container">
      <div className="scrobits__blog-container_groupA">
        <Article
          author="Digvijay Jadhav"
          imgUrl="https://media.istockphoto.com/photos/cyber-security-web-development-and-work-in-it-concept-picture-id1289411982?b=1&k=20&m=1289411982&s=170667a&w=0&h=0R3OXR4L6LOGphYA3sul4bWQwpGj_DSl05ENiP2kRZg="
          date="Dec 7, 2021"
          description="In the previous blog I talked about why one should prefer react for Frontend. Now we'll take a look at React developer roadmap that will guide you through your journey from being a novice developer to a skilled plus experienced developer over time.

          React is one of the most popular JavaScript library for designing rich and interactive User Interfaces.

          Below is the mind-map of learning React."
          text="Roadmap for React JS 2022"
          link="https://dev.to/digvijayjadhav98/roadmap-for-react-js-2022-4ccn"
        />
      </div>

      <div className="scrobits__blog-container_groupB">
        <Article
          imgUrl="https://res.cloudinary.com/practicaldev/image/fetch/s--CvVrf45q--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/tj8s2dlcur1x0tdks3va.jpeg"
          author="Digvijay Jadhav"
          date="Oct 23, 2021"
          text="Why choose React for frontend?"
          description="Before I dive into some of the cool things you can do with React, lets understand what is React."
          link="https://dev.to/digvijayjadhav98/why-choose-react-for-frontend-4m23"
        />
        <Article
          imgUrl="https://abhijeetgavali.notion.site/image/https%3A%2F%2Fwww.datocms-assets.com%2F30881%2F1635851498-newmobileherographic.png%3Fauto%3Dformat%26auto%3Dformat%26w%3D1440?table=block&id=223c7fce-e969-4ecd-a91e-ea8426900463&spaceId=5c1d7dcf-6a74-450c-8612-6c780c8e1c07&width=2000&userId=&cache=v2"
          date="Sep 26, 2021"
          author="Abhijeet Gavali"
          text="Setting up RASA"
          link="https://abhijeetgavali.notion.site/RASA-installation-guide-223c7fcee9694ecda91eea8426900463"
        />
        <Article
          imgUrl="https://miro.medium.com/max/2000/1*y1hpB6NUdz2zoRWS8fEUaQ.jpeg"
          date="Oct 5, 2021"
          author="Sohan Kale"
          text="Flutter CI with Github Workflow/Action on your app/package"
          link="https://link.medium.com/zQjq5GOP6jb"
        />
        <Article
          imgUrl="https://res.cloudinary.com/practicaldev/image/fetch/s--xapuJpyw--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/1fj94y9nx920uuukow37.png"
          author="Digvijay Jadhav"
          date="Posted on Feb 1 2022"
          link="https://dev.to/digvijayjadhav98/code-documentation-a-guide-for-beginners-4cj7"
          text="Code Documentation: A Guide for Beginner's🎯"
        />
      </div>
    </div>
  </section>
);

export default Blog;
